import React from 'react';
import { Outlet } from 'react-router-dom';

const ContactHome = () => {
  return (
   <>
   <div className="row">
        <div className="col-12">
          <div className="card my-4">
          

            <Outlet /> 
            </div>
            </div>
            </div> 
            </>
  );
};




export default ContactHome;